module.exports = __webpack_public_path__ + "static/img/CO.72f76a8e.svg";